module.exports = __webpack_public_path__ + "img/laboratorio2_4-3_682.3be68794.webp";